const Slider = () => {

    document.addEventListener('DOMContentLoaded', () => {
        const slider = document.querySelector('.knowledge-stats__row');
        const slides = document.querySelectorAll('.knowledge-stats__col');
    
        // Add touch drag support
        let isDown = false;
        let startX;
        let scrollLeft;
    
        slider.addEventListener('mousedown', (e) => {
            isDown = true;
            slider.classList.add('active');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });
    
        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('active');
        });
    
        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('active');
        });
    
        slider.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 2; // Adjust scrolling sensitivity
            slider.scrollLeft = scrollLeft - walk;
        });
    
        // Ensure proper alignment when resizing
        window.addEventListener('resize', () => {
            if (window.innerWidth > 768) {
                slider.scrollLeft = 0;
            }
        });

    });
}

export default Slider;